import { Controller } from '@hotwired/stimulus'

export default class PasswordFormController extends Controller {
  static targets = ['passwordSwitch', 'fieldsContainer']

  connect() {
    this.togglePasswordFields()
  }

  togglePasswordFields() {
    const checked = this.passwordSwitchTarget.checked

    this.passwordSwitchTarget.value = checked
    this.fieldsContainerTarget.classList.toggle('animating-in', checked)
    this.fieldsContainerTarget.classList.toggle('hidden', !checked)
    this.fieldsContainerTarget.classList.toggle('animating-out', !checked)
  }
}
